/**
 * Sign-in screen. Single button kicks off the MSAL redirect flow.
 *
 * We deliberately use redirect over popup because:
 *   - Plays nicer with strict cookie policies
 *   - Works inside iframes if we ever embed (popup blockers)
 *   - Simpler error handling — the redirect-callback runs in main.tsx
 */

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../lib/msal";

export function Login() {
  const { instance } = useMsal();

  return (
    <div className="grid place-items-center h-full bg-gradient-to-br from-rogue-100 to-rogue-200">
      <div className="bg-white rounded-2xl shadow-lg pad-fluid w-[min(90vw,28rem)] text-center">
        <div className="text-3xl font-bold text-rogue-900 mb-2">Atticor-Rogue</div>
        <div className="text-rogue-600 mb-8 text-sm">Programmable contact center</div>
        <button
          onClick={() => instance.loginRedirect(loginRequest)}
          className="w-full bg-rogue-700 hover:bg-rogue-800 text-white font-medium rounded-lg pad-fluid transition-colors"
        >
          Sign in with Microsoft
        </button>
        <div className="text-xs text-rogue-500 mt-6">
          You'll be redirected to Entra ID. After sign-in, an Operations Manager must activate your account.
        </div>
      </div>
    </div>
  );
}
